import { Link } from 'react-router-dom';

export default function LegalLinks() {
    return (
        <p className="text-center text-xs text-zinc-500 mt-8 leading-relaxed">
            By continuing, you agree to our{' '}
            <Link to="/terms" className="text-zinc-400 hover:text-white underline transition-colors">
                Terms of Service
            </Link>{' '}
            and{' '}
            <Link to="/privacy" className="text-zinc-400 hover:text-white underline transition-colors">
                Privacy Policy
            </Link>
            .
        </p>
    );
}
